import { Link } from "react-router-dom";
import Seo from "@/components/common/Seo";
import GlowOrbs from "@/components/common/GlowOrbs";

export default function NotFound() {
  return (
    <div className="relative min-h-[70vh] flex items-center justify-center px-5 overflow-hidden" data-testid="page-404">
      <Seo title="Page not found" description="The page you are looking for does not exist." path="/404" />
      <GlowOrbs />
      <div className="relative text-center max-w-lg">
        <p className="font-poppins text-8xl sm:text-9xl font-semibold text-gradient tracking-tighter">404</p>
        <h1 className="font-poppins text-2xl sm:text-3xl text-white font-semibold mt-4">Page not found</h1>
        <p className="font-inter text-white/50 mt-3">The link is broken or the page has moved. Let's get you back on track.</p>
        <Link
          to="/"
          className="inline-flex mt-8 items-center gap-2 text-white font-inter font-medium text-sm px-6 py-3.5 rounded-full"
          style={{ background: "linear-gradient(120deg, #1E3A8A, #10B981)" }}
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
